import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class FilesAPI extends API {
	post(data) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const bitacoraApi = new FilesAPI('/bitacora-accion');
export const startLog = (message) => {
	bitacoraApi.post({ accion: message });
};
